
import Color from "../../../model/color";

import RawColor from "./RawColor";

type PreviewBackgroundColor = RawColor | null | undefined;

export const DEFAULT_PREVIEW_BACKGROUND_COLOR: RawColor = {
    name: "default",
    r: 0,
    g: 0,
    b: 0,
    a: 1
};

export function isSamePreviewBackgroundColor(colorA: PreviewBackgroundColor, colorB: PreviewBackgroundColor) {
    if (!colorA) {
        return !colorB;
    }

    if (!colorB) {
        return false;
    }

    const colorModelA = new Color(colorA);

    return colorModelA.equals(colorB);
}

export function isDefaultPreviewBackgroundColor(color: PreviewBackgroundColor): boolean {
    if (!color) {
        return true;
    }

    const colorModel = new Color(color);

    return colorModel.equals(DEFAULT_PREVIEW_BACKGROUND_COLOR);
}

export default PreviewBackgroundColor;
